/* eslint-disable prettier/prettier */
import Vue from "vue";
import {MLanguage, MLCreate, MLInstaller} from "vue-multilanguage";

Vue.use(MLInstaller);

export default new MLCreate({
    initial: process.env.VUE_APP_LANG,
    save: process.env.NODE_ENV === "production",
    languages: [
        new MLanguage("RU").create({
            programTitle: "EPI online",
            momentLocale: "ru",
            chartLocale: "ru",
            backButton: "Назад",
            dateTimeFormat: "DD.MM.YYYY HH:mm:ss",
            dateFormat: "DD.MM.YYYY",
            timeFormat: "HH:mm:ss",
            yes: "Да",
            no: "Нет",
            language: "Язык",

            loginTitle: "Авторизация",
            loginForgotLink: "Забыли пароль?",
            loginButton: "Войти",

            formEmailLabel: "Адрес электронной почты",
            formPassLabel: "Пароль",
            formRuleRequired: "Данное поле является обязательным",
            formRuleRequired2: "Это поле обязательно",
            formRuleRequired3: "Поле обязателько для заполнения",
            formRuleEmailErr: "Некорректный адрес электронной почты",
            formRulePassMin: "Минимальная длина пароля 8 символов.",
            formPhoneLabel: "Телефон",
            formNameLabel: "Имя",
            formInnLabel: "ИНН",
            formRuleInnErr: "Введите корректный ИНН",
            formRulePhoneErr: "Введите корректный номер телефона",
            formTypeLabel: "Тип",
            formClientLabel: "Клиент",
            formCouponNumberLabel: "Код промокода(не обязательно)",
            formCouponDiscountLabel: "Размер скидки в процентах",
            formStartDateLabel: "Дата начала",
            formEndDateLabel: "Дата окончания",
            formDescLabel: "Описание",
            formCancelButton: "Отмена",
            formEditButton: "Редактировать",
            formAddButton: "Добавить",
            formUpdateButton: "Обновить",
            formSubmitButton: "Сохранить",
            formOkButton: "OK",
            formCouponNumberError: "Должно быть 6 цифр",
            formPercentError: "Должно быть от 0 до 100",
            formValidateError: "Провертье все поля на заполнение",
            formValidateError2: "Проверьте поля на правильность заполнения",
            formScheduleStartTimeLabel: "Срок действия промокода",
            formScheduleEndTimeLabel: "Время окончания",
            formScheduleDiscountLabel: "Размер скидки в процентах",
            formRequiredLabel: "Обязательные поля",
            formCouponLimitLabel: "Лимит",
            formUserNameLabel: "ФИО",
            formPasswordLabel: "Пароль",
            formPassword2Label: "Повторите пароль",
            formValueErr: "Неверное значение",
            formEmailErr: "Неверный email!",
            formUpdateSuccessMsg: "Данные успешно обновлены.",

            modalCloseButton: "Закрыть",

            unknownMsg: "Неизвестно",
            apiErrorMsg: "Ошибка, пожалуйста попробуйте позже",

            tableUpdateButton: "Обновить",
            tableEditButton: "Редактировать",
            tableDeleteButton: "Удалить",
            asyncTableSearch: "Поиск",
            asyncTableDataErr: "Ошибка при получении данных",

            forgotPasswordTitle: "Восстановление пароля",
            forgotEmailHint: "На данный адрес будет отправлена ссылка на восстановление пароля.",
            forgotSubmitButton: "Продолжить",
            forgotCancelButton: "Отмена",
            forgotSuccessMessage: "Ссылка на восстановление отправлена.",

            resetPasswordTitle: "Восстановление пароля",
            resetPasswordTokenTimeout: "Данная ссылка уже не действительна.",
            resetPasswordPassLabel: "Новый пароль",
            resetPasswordPass2Label: "Повторите пароль",
            resetPasswordSubmitButton: "Сохранить",
            resetPasswordPassRepeatErr: "Пароли не совпадают",
            resetPasswordSuccessMsg: "Пароль успешно изменен.",
            resetPasswordErrorMsg: "Не удалось изменить пароль.",

            notFoundTitle: "404 - Страница не найдена!",
            notFoundButton: "На главную",

            cashboxTitle: "Касса {0}",
            cashboxTab1: "Общая информация",
            cashboxTab2: "Логи",
            cashboxTab3: "Чеки",
            cashboxTab1Title: "Касса",
            cashboxSerialNumber: "Серийный номер",
            cashboxModelCode: "Код модели",
            cashboxModelName: "Название модели",
            cashboxUsbPath: "Путь к USB-устройству",
            cashboxCashierName: "Кассир",
            casboxsTitle: "ККТ",
            cashboxsErrorMsg: "Ошибка при получении данных о кассах",
            cashboxErrorMsg: "Ошибка при получении данных о кассе",

            clientsTitle: "Клиенты",
            clientsAddButton: "Добавить клиента",
            clientsAddTitle: "Добавление клиента",
            clientsUpdateTitle: "Обновление данных клиента",
            clientsCancelButton: "Отмена",
            clientsUpdateButton: "Обновить",
            clientsSubmitButton: "Добавить",
            clientsTableName: "Наименование",
            clientsTableInn: "ИНН",
            clientsTablePhone: "Телефон",
            clientsTableOrgName: "Организация",
            clientsTableOrgInn: "ИНН организации",
            clientsDeleteLabel: "Удалить этого клиента?",
            clientsDeleteErr: "Не удалось удалить данные о клиенте",
            clientsUpdateSuccessMsg: "Данные клиента обновлены",
            clientsUpdateErrorMsg: "Не удалось обновить данные клиента",
            clientsAddSuccessMsg: "Клиент добавлен",
            clientsAddErrorMsg: "Не удалось добавить клиента",
            clientsErrorMsg: "Ошибка при получении данных о клиентах",
            clientErrorMsg: "Ошибка при получении данных о клиенте",

            couponsTitle: "Промокоды",
            couponsAddButton: "Добавить промокод",
            couponsAddTitle: "Добавление промокода",
            couponsTypeA: "Акционный (A)",
            couponsTypeC: "Корпоративный (C)",
            couponsTypeX: "Персональный (X)",
            couponsHeaderType: "Тип",
            couponsHeaderCode: "Код",
            couponsHeaderStartDate: "Дата начала",
            couponsHeaderEndDate: "Дата окончания",
            couponsHeaderDiscount: "Размер скидки",
            couponsHeaderCount: "Количество применений",
            couponsHeaderClient: "Клиент",
            couponsHeaderOrgName: "Наименование компании",
            couponsHeaderDesc: "Описание",
            couponsAddSuccessMsg: "Промокод создан",
            couponsAddErrorMsg: "Не удалось добавить промокод",
            couponsDeleteLabel: "Удалить этот промокод?",
            couponsDeleteErr: "Не удалось удалить данные о промокоде",
            couponsEditButton: "Редактировать промокод",
            couponDiscountTitle: "Текущая скидка",
            couponPeriodTitle: "Период действия",
            couponServiceTitle: "Услуга",
            couponLimitTitle: "Лимит",
            couponUsedTitle: "Использовано всего",
            couponItemTitle: "Промокод для услуги",
            couponScheduleEditTitle: "Редактирование сроков",
            couponScheduleTitle: "Срок действия",
            couponUpdateTitle: "Обновление промокода",
            couponScheduleAddBtn: "Добавить сроки действия",
            couponServiceAddErr: "Ошибка при добавлении режима,\nПровертье наличие терминала с этим режимом",
            couponScheduleDeleteLabel: "Удалить расписание?",
            couponScheduleDeleteErr: "Ошибка при удалении расписания",
            couponScheduleDeleteErr2: "Ошибка при удалении данных о графике промокода",
            couponScheduleAddErr: "Ошибка при добавлении расписания.\nПровертье правильность заполнения полей",
            couponScheduleAddErr2: "Ошибка при добавлении расписания",
            couponScheduleEditErr: "Ошибка при редактировании расписания.\nПровертье правильность заполнения полей",
            couponScheduleEditErr2: "Ошибка при редактировании расписания",
            couponsErrorMsg: "Ошибка при получении данных о промокодах",
            couponErrorMsg: "Ошибка при получении данных о промокоде",
            couponsScheduleErrorMsg: "Ошибка при получении данных о графике промокодов",
            couponScheduleErrorMsg: "Ошибка при получении данных о графике промокода",
            couponRemoveLimit: "Убрать лимит",

            memberJoinTitle: "Регистрация",
            memberJoinTokenTimeout: "Данная ссылка уже не действительна.",
            memberJoinSuccessMsg: "Регистрация прошла успешно.",
            memberJoinErrorMsg: "Не удалось зарегестрировать пользователя.",
            membersTitle: "Сотрудники",
            membersAddButton: "Добавить сотрудника",
            membersAddTitle: "Добавление сотрудника",
            membersHeaderUsername: "ФИО",
            membersHeaderEmail: "Емайл",
            membersHeaderDateCreate: "Дата добавления",
            membersRegistrationSuccessMsg: "Ссылка на регистрацию отправлена.",
            membersAddSuccessMsg: "Сотрудник добавлен.",
            membersDeleteLabel: "Удалить этого сотрудника из организации?",
            membersAsyncTableStartBtn: "Начать работу",
            membersAsyncTableEndBtn: "Закончить работу",

            adminMenuTitle: "Администрирование",
            adminMenuOrg: "Организации",
            adminMenuClient: "Клиенты",
            adminMenuCoupon: "Промокоды",
            adminMenuRep: "Отчеты",
            menuListCashbox: "ККТ",
            menuListTerminal: "Терминалы",
            menuListMember: "Сотрудники",

            organizationsTitle: "Организации",
            organizationsHeaderName: "Наименование",
            organizationsHeaderOwner: "Владелец",
            organizationsHeaderInn: "ИНН",
            organizationsHeaderPhone: "Телефон",
            organizationsHeaderEmail: "E-mail",
            organizationsErrorMsg: "Ошибка при получении данных организации",

            reportsTitle: "Анализ продаж",
            reportsPeriodLabel: "Выберите период",
            reportsOrgLabel: "Организация",
            reportsTermLabel: "Терминал",
            reportsMemberLabel: "Сотрудник",
            reportsPayTypeLabel: "Тип оплаты",
            reportsClientLabel: "Клиент",
            reportsCountTitle: "Количество моек по типам услуг",
            reportsPaymentTitle: "Выручка по типам услуг",
            reportsDailyTitle: "Выручка",
            reportsDailyCountTitle: "Количество моек",
            reportsHourTitle: "Загруженность дня по часам",
            reportsStatsTitle: "Оплата по услугам",
            reportsStatsHeaderService: "Услуга",
            reportsStatsHeaderCount: "Количество",
            reportsStatsHeaderPercentPast: "% к прошлому году",
            reportsStatsHeaderCost: "Сумма",
            reportsStatsHeaderDiscount: "Скидка",
            reportsStatsHeaderRevenue: "Оплачено",
            reportsStatsHeaderMiddle: "Средний чек",
            reportsStatsManMsg: "Ручной запуск",
            reportsStatsTotal: "Итого (без ручных запусков)",
            reportsLogentryTitle: "История",
            reportsLogentryDownloadBtn: "Скачать",
            reportsLogentryDownloadClientBtn: "Отчет по клиентам",
            reportsLogentryHeadService: "Услуга",
            reportsLogentryHeadServiceType: "Тип услуги",
            reportsLogentryHeadPrice: "Стоимость",
            reportsLogentryHeadDiscount: "Скидка",
            reportsLogentryHeadAmount: "Сумма оплаты",
            reportsLogentryHeadMode: "Режим",
            reportsLogentryHeadStart: "Начало",
            reportsLogentryHeadEnd: "Окончание",
            reportsLogentryHeadTime: "Длительность",
            reportsLogentryHeadType: "Тип запуска",
            reportsLogentryHeadState: "Состояние",
            reportsLogentryHeadDate: "Дата",
            reportsLogentryHeadMember: "Сотрудник",
            reportsLogentryNoPay: "Нет оплаты",
            reportsLogentryModeLabel: "Режим",
            reportsLogentryWashManually: "Ручной",
            reportsLogentryWashAuto: "Автоматический",
            reportsLogentryWashEnd: "Завершена",
            reportsLogentryWashNoEnd: "Не завершена",
            reportsDumpTitle: "Мойка от",
            reportsDumpSubTitle: "c {0} по {1} (Длительность {2})",
            reportsAllLabel: "Все",
            reportsPayTypeCouponLabel: "С промокодом",
            reportsPayTypeNoCouponLabel: "Без промокода",
            reportServiceManually: "Ручной запуск",
            reportsHourDatasetLabel: "Данные за период с {0} по {1}",
            reportsDownloadErrorMsg: "Не удалось скачать шаблоны.",

            terminalsTitle: "Терминалы",
            terminalsAddButton: "Добавить терминал",
            terminalsAddTitle: "Добавление терминала",
            terminalsSerialNumberLabel: "Серийный номер",
            terminalsActiveCodeLabel: "Код активации",
            terminalsActiveDateLabel: "Дата активации",
            terminalsAddressLabel: "Адрес",
            terminalsMemberLabel: "Активный сотрудник",
            terminalsDateCreateLabel: "Дата добавления",
            terminalsDeleteLabel: "Удалить этот терминал?",
            terminalsDeleteErr: "Не удалось удалить терминал",
            terminalsAddErr: "Не удалось добавить терминал",
            terminalsErrorMsg: "Ошибка при получении данных терминала",
            terminalTitle: "Терминал",
            terminalHeaderInfo: "Общая информация",
            terminalHeaderService: "Услуги",
            terminalHeaderGrafik: "График цен",
            terminalHeaderTO: "ТО",
            terminalHeaderMessages: "История событий",
            terminalMaintenanceAddBtn: "Добавить ТО",
            terminalMaintenanceEditTitle: "Редактировать ТО",
            terminalMaintenanceDate: "Дата проведения ТО",
            terminalMaintenanceNext: "Следующее ТО",
            terminalMaintenanceTechName: "Имя Специалиста",
            terminalMaintenanceNote: "Заметки",
            terminalMaintenanceId: "Номер заявки ТО",
            terminalMaintenanceDateCreate: "дата создания заявки",
            terminalMaintenanceDeleteSuccess: "Данные удалены",
            terminalMaintenanceAddSuccess: "ТО добавлено",
            terminalMaintenanceEditSuccess: "ТО отредактировано",
            terminalMaintenanceDeleteError: "Ошибка при удалении данных",
            terminalMaintenanceAddError: "Ошибка при создании ТО",
            terminalMaintenanceEditError: "Ошибка при редатировании ТО",
            terminalMessagesMessage: "Описание",
            terminalMessagesServiceName: "Режим",
            terminalMessagesDateCreated: "Дата и время",
            terminalSendButton: "Деньги!",
            terminalSettingTitle: "Настройки",
            terminalBonusPayLabel: "Оплата бонусами",
            terminalAfterPayLabel: "Начисление бонусов после оплаты",
            terminalBonusLabel: "Бонусы",
            terminalBonusPercentLabel: "Размер начисления бонусов в % от стоимости услуги",
            terminalBonusScheduleTitle: "График изменения начисления бонусов",
            terminalBonusScheduleStart: "Время начала",
            terminalBonusScheduleEnd: "Время окончания",
            terminalBonusSchedulePercent: "Бонусы в %",
            terminalReboot: "Перезагрузить",
            terminalRebooting: "Перезагружается",
            terminalStopWash: "Остановить мойку",
            terminalStopDeltaWash: "Сброс",
            terminalCancelWash: "Отмена",
            terminalOpenGate: "Открыть ворота",
            terminalCloseGate: "Закрыть ворота",
            terminalRunWash: "Запустить мойку",
            terminalPauseWash: "Пауза",
            terminalPlayWash: "Пуск",
            terminalOrgName: "Организация",
            terminalScreenTitle: "Экран терминала",
            terminalStateTitle: "Состояние терминала",
            terminalErrorTitle: "Ошибки",
            terminalHeaderStatus: "Статус",
            terminalHeaderPayTerm: "Терминал оплаты",
            terminalHeaderControlDevice: "Связь с автоматизацией",
            terminalHeaderStarted: "Дата последнего включения",
            terminalHeaderTempHum: "Температура / Влажность в терминале",
            terminalHeaderCooler: "Кулер",
            terminalHeaderHeater: "Обогреватель",
            terminalHeaderBackLight: "Подсветка",
            terminalHeaderBoxTemp: "Температура в боксе",
            terminalOnLabel: "Включен",
            terminalOffLabel: "Выключен",
            terminalNotAvail: "Недоступен",
            terminalOn2Label: "Включена",
            terminalOff2Label: "Выключена",
            terminalLocked: "Заблокировано",
            terminalCashCollector: "Купюроприемник",
            terminalHideControl: "Скрыть кнопки управления",
            terminalStatesSelectScreen: "Выбор режима",
            terminalStatesWaitPay: "Ожидание оплаты",
            terminalStatesPayment: "Оплата",
            terminalStatesWashing: "Идет мойка",
            terminalSendSuccessMsg: "Сообщение успешно отправлено.",
            terminalPriceScheduleAddBtn: "Добавить сроки изменения цены",
            terminalPriceScheduleAddTitle: "Новая цена",
            terminalPriceScheduleEditTitle: "Редактирование цены",
            terminalPriceScheduleStart: "Время начала акции",
            terminalPriceScheduleEnd: "Время окончания",
            terminalPriceScheduleType: "Тип услуги",
            terminalPriceSchedulePrice: "Цена",
            terminalPriceScheduleDeleteTitle: "Удалить расписание?",
            terminalPriceScheduleDeleteErr: "Ошибка при удалении расписания",
            terminalPriceScheduleAddErr: "Ошибка при создании расписания.\nПровертье правильность заполнения полей",
            terminalPriceScheduleEditErr: "Ошибка при редактировании расписания.\nПровертье правильность заполнения полей",
            terminalPriceScheduleEditErr2: "Ошибка при редактировании расписания",
            terminalServiceCreateTitle: "Новая услуга",
            terminalServiceEditTitle: "Редактирование услуги",
            terminalServiceEditSubTitle: "Режим услуги",
            terminalServiceName: "Заголовок",
            terminalServiceFullName: "Название в чеке",
            terminalServicePrice: "Цена",
            terminalServiceIsWash: "Запуск мойки",
            terminalServiceIcon: "Изображение",
            terminalServiceDesc: "Описание",
            terminalServiceCode: "Код услуги",
            terminalServiceRelPos: "Текущая позиция",
            terminalServiceCode1Label: "Режим 1",
            terminalServiceCode2Label: "Режим 2",
            terminalServiceCode3Label: "Режим 3",
            terminalServiceCode4Label: "Режим 4",
            terminalServiceDeleteTitle: "Вы хотите удалить услугу?",
            terminalServiceUpdateSuccess: "Услуга обновлена",
            terminalServiceUpdateError: "Услуга не обновлена, попробуйте еще раз",
            terminalServiceCreateSuccess: "Услуга создана",
            terminalServiceCreateError: "Услуга не создана, попробуйте еще раз",

            couponOnLabel: "Включены",
            couponOffLabel: "Выключены",
            couponOnBtn: "Включить",
            couponOffBtn: "Выключить",
            couponPeriodLabel: "Выберите период",
            couponPieTitle: "Количество использований промокода за указанный период",

            apiErrorNoConnect: "Отсутствует соединение с сервером.",
            apiError403: "У вас недостаточно прав для выполнения этой операции.",
            apiError404: "Не найдено",
            apiError500: "Упс! Что-то пошло не так.",
        }),

        new MLanguage("EN").create({
            programTitle: "EPI online",
            momentLocale: "en",
            chartLocale: "en",
            backButton: "Back",
            dateTimeFormat: "DD.MM.YYYY HH:mm:ss",
            dateFormat: "DD.MM.YYYY",
            timeFormat: "HH:mm:ss",
            yes: "Yes",
            no: "No",
            language: "Language",

            loginTitle: "Login",
            loginForgotLink: "Forgot your password?",
            loginButton: "Login",

            formEmailLabel: "Email address",
            formPassLabel: "Password",
            formRuleRequired: "This field is required",
            formRuleRequired2: "This field is required",
            formRuleRequired3: "Required field",
            formRuleEmailErr: "Invalid email address",
            formRulePassMin: "The minimum password length is 8 characters.",
            formPhoneLabel: "Phone",
            formNameLabel: "Name",
            formInnLabel: "INN",
            formRuleInnErr: "Please enter correct INN",
            formRulePhoneErr: "Please enter a valid phone number",
            formTypeLabel: "Type",
            formClientLabel: "Client",
            formCouponNumberLabel: "Coupon code (optional)",
            formCouponDiscountLabel: "Discount amount in percent",
            formStartDateLabel: "Start date",
            formEndDateLabel: "End date",
            formDescLabel: "Description",
            formCancelButton: "Cancel",
            formEditButton: "Edit",
            formAddButton: "Add",
            formUpdateButton: "Update",
            formSubmitButton: "Save",
            formOkButton: "OK",
            formCouponNumberError: "Must be 6 digits",
            formPercentError: "Must be between 0 and 100",
            formValidateError: "Validate all fields for filling",
            formValidateError2: "Check the fields for correct filling",
            formScheduleStartTimeLabel: "Coupon expiration date",
            formScheduleEndTimeLabel: "End Time",
            formScheduleDiscountLabel: "Discount amount in percent",
            formRequiredLabel: "Required fields",
            formCouponLimitLabel: "Limit",
            formUserNameLabel: "Full name",
            formPasswordLabel: "Password",
            formPassword2Label: "Repeat password",
            formValueErr: "Invalid value",
            formEmailErr: "Invalid email!",
            formUpdateSuccessMsg: "Data has been successfully updated.",

            modalCloseButton: "Close",

            unknownMsg: "Unknown",
            apiErrorMsg: "Error, please try again later",

            tableUpdateButton: "Update",
            tableEditButton: "Edit",
            tableDeleteButton: "Delete",
            asyncTableSearch: "Search",
            asyncTableDataErr: "Error retrieving data",

            forgotPasswordTitle: "Password Recovery",
            forgotEmailHint: "A link to reset your password will be sent to this address.",
            forgotSubmitButton: "Continue",
            forgotCancelButton: "Cancel",
            forgotSuccessMessage: "Recovery link has been sent.",

            resetPasswordTitle: "Password recovery",
            resetPasswordTokenTimeout: "This link is no longer valid.",
            resetPasswordPassLabel: "New Password",
            resetPasswordPass2Label: "Please repeat password",
            resetPasswordSubmitButton: "Save",
            resetPasswordPassRepeatErr: "Passwords do not match",
            resetPasswordSuccessMsg: "Password changed successfully.",
            resetPasswordErrorMsg: "Failed to change password.",

            notFoundTitle: "404 - Page not found!",
            notFoundButton: "Home",

            cashboxTitle: "Cashbox {0}",
            cashboxTab1: "General information",
            cashboxTab2: "Logs",
            cashboxTab3: "Checks",
            cashboxTab1Title: "Cashier",
            cashboxSerialNumber: "Serial Number",
            cashboxModelCode: "Model Code",
            cashboxModelName: "Model Name",
            cashboxUsbPath: "Path to USB device",
            cashboxCashierName: "Cashier",
            casboxsTitle: "KKT",
            cashboxsErrorMsg: "Error while receiving cashbox data",
            cashboxErrorMsg: "Error while receiving cashbox data",

            clientsTitle: "Clients",
            clientsAddButton: "Add client",
            clientsAddTitle: "Add client",
            clientsUpdateTitle: "Client data update",
            clientsCancelButton: "Cancel",
            clientsUpdateButton: "Update",
            clientsSubmitButton: "Add",
            clientsTableName: "Name",
            clientsTableInn: "INN",
            clientsTablePhone: "Phone",
            clientsTableOrgName: "Organization",
            clientsTableOrgInn: "TIN of the organization",
            clientsDeleteLabel: "Delete this client?",
            clientsDeleteErr: "Failed to delete client data",
            clientsUpdateSuccessMsg: "Client data updated",
            clientsUpdateErrorMsg: "Failed to update client details",
            clientsAddSuccessMsg: "Client added",
            clientsAddErrorMsg: "Failed to add client",
            clientsErrorMsg: "Error retrieving client data",
            clientErrorMsg: "Error retrieving client data",

            couponsTitle: "Coupons",
            couponsAddButton: "Add coupon",
            couponsAddTitle: "Coupon Adding",
            couponsTypeA: "Promotional (A)",
            couponsTypeC: "Corporate (C)",
            couponsTypeX: "Personal (X)",
            couponsHeaderType: "Type",
            couponsHeaderCode: "Code",
            couponsHeaderStartDate: "Start Date",
            couponsHeaderEndDate: "End date",
            couponsHeaderDiscount: "Discount amount",
            couponsHeaderCount: "Count",
            couponsHeaderClient: "Client",
            couponsHeaderOrgName: "Company Name",
            couponsHeaderDesc: "Description",
            couponsAddSuccessMsg: "Coupon created",
            couponsAddErrorMsg: "Failed to add coupon",
            couponsDeleteLabel: "Delete this coupon?",
            couponsDeleteErr: "Failed to delete coupon data",
            couponsEditButton: "Edit Coupon",
            couponDiscountTitle: "Current Discount",
            couponPeriodTitle: "Validity Period",
            couponServiceTitle: "Service",
            couponLimitTitle: "Limit",
            couponUsedTitle: "Used",
            couponItemTitle: "Coupon for the service",
            couponScheduleEditTitle: "Editing Due Dates",
            couponScheduleTitle: "Expiry Date",
            couponUpdateTitle: "Coupon Update",
            couponScheduleAddBtn: "Add expiration dates",
            couponServiceAddErr: "Error while adding a mode, \ nChecking if there is a terminal with this mode",
            couponScheduleDeleteLabel: "Delete schedule?",
            couponScheduleDeleteErr: "Error deleting schedule",
            couponScheduleDeleteErr2: "Error deleting coupon schedule data",
            couponScheduleAddErr: "An error occurred while adding a schedule. \ nChecking if the fields were filled in correctly",
            couponScheduleAddErr2: "Error adding schedule",
            couponScheduleEditErr: "Error while editing the schedule. \ nChecking the correctness of filling in the fields",
            couponScheduleEditErr2: "Error while editing schedule",
            couponsErrorMsg: "Error retrieving coupon data",
            couponErrorMsg: "Error retrieving coupon data",
            couponsScheduleErrorMsg: "Error retrieving coupon schedule data",
            couponScheduleErrorMsg: "Error retrieving coupon schedule data",
            couponRemoveLimit: "Remove Limit",

            memberJoinTitle: "Registration",
            memberJoinTokenTimeout: "This link is no longer valid.",
            memberJoinSuccessMsg: "Registration was successful.",
            memberJoinErrorMsg: "Failed to register user.",
            membersTitle: "Employees",
            membersAddButton: "Add an employee",
            membersAddTitle: "Adding an employee",
            membersHeaderUsername: "Full name",
            membersHeaderEmail: "Email",
            membersHeaderDateCreate: "Date added",
            membersRegistrationSuccessMsg: "Registration link has been sent.",
            membersAddSuccessMsg: "Member added.",
            membersDeleteLabel: "Are you sure you want to remove this employee from the organization?",
            membersAsyncTableStartBtn: "Get Started",
            membersAsyncTableEndBtn: "End Work",

            adminMenuTitle: "Administration",
            adminMenuOrg: "Organizations",
            adminMenuClient: "Clients",
            adminMenuCoupon: "Coupons",
            adminMenuRep: "Reports",
            menuListCashbox: "ККТ",
            menuListTerminal: "Terminals",
            menuListMember: "Employees",

            organizationsTitle: "Organizations",
            organizationsHeaderName: "Name",
            organizationsHeaderOwner: "Owner",
            organizationsHeaderInn: "INN",
            organizationsHeaderPhone: "Phone",
            organizationsHeaderEmail: "E-mail",
            organizationsErrorMsg: "Error retrieving organization data",

            reportsTitle: "Sales Analysis",
            reportsPeriodLabel: "Select period",
            reportsOrgLabel: "Organization",
            reportsTermLabel: "Terminal",
            reportsMemberLabel: "Employee",
            reportsPayTypeLabel: "Payment type",
            reportsClientLabel: "Client",
            reportsCountTitle: "Number of car washes by service type",
            reportsPaymentTitle: "Revenue by Service Type",
            reportsDailyTitle: "Revenue",
            reportsDailyCountTitle: "Number of washes",
            reportsHourTitle: "Daily Hourly Workload",
            reportsStatsTitle: "Payment by Service",
            reportsStatsHeaderService: "Service",
            reportsStatsHeaderCount: "Count",
            reportsStatsHeaderPercentPast: "% last year",
            reportsStatsHeaderCost: "Amount",
            reportsStatsHeaderDiscount: "Discount",
            reportsStatsHeaderRevenue: "Paid",
            reportsStatsHeaderMiddle: "Average bill",
            reportsStatsManMsg: "Manual launch",
            reportsStatsTotal: "Total",
            reportsLogentryTitle: "History",
            reportsLogentryDownloadBtn: "Download",
            reportsLogentryDownloadClientBtn: "Client report",
            reportsLogentryHeadService: "Service",
            reportsLogentryHeadServiceType: "Service type",
            reportsLogentryHeadPrice: "Cost",
            reportsLogentryHeadDiscount: "Discount",
            reportsLogentryHeadAmount: "Payment Amount",
            reportsLogentryHeadMode: "Mode",
            reportsLogentryHeadStart: "Start",
            reportsLogentryHeadEnd: "End",
            reportsLogentryHeadTime: "Duration",
            reportsLogentryHeadType: "Startup Type",
            reportsLogentryHeadState: "Status",
            reportsLogentryHeadDate: "Date",
            reportsLogentryHeadMember: "Employee",
            reportsLogentryNoPay: "No payment",
            reportsLogentryModeLabel: "Mode",
            reportsLogentryWashManually: "Manual",
            reportsLogentryWashAuto: "Automatic",
            reportsLogentryWashEnd: "Completed",
            reportsLogentryWashNoEnd: "Incomplete",
            reportsDumpTitle: "Sink from",
            reportsDumpSubTitle: "from {0} to {1} (Duration {2})",
            reportsAllLabel: "Everyone",
            reportsPayTypeCouponLabel: "With a promo code",
            reportsPayTypeNoCouponLabel: "No promo code",
            reportServiceManually: "Start manually",
            reportsHourDatasetLabel: "Data for the period from {0} to {1}",
            reportsDownloadErrorMsg: "Failed to download templates.",

            terminalsTitle: "Terminals",
            terminalsAddButton: "Add terminal",
            terminalsAddTitle: "Adding a terminal",
            terminalsSerialNumberLabel: "Serial Number",
            terminalsActiveCodeLabel: "Activation Code",
            terminalsActiveDateLabel: "Activation date",
            terminalsAddressLabel: "Address",
            terminalsMemberLabel: "Active employee",
            terminalsDateCreateLabel: "Date added",
            terminalsDeleteLabel: "Delete this terminal?",
            terminalsDeleteErr: "Failed to delete terminal",
            terminalsAddErr: "Failed to add terminal",
            terminalsErrorMsg: "Error receiving terminal data",
            terminalTitle: "Terminal",
            terminalHeaderInfo: "General Information",
            terminalHeaderService: "Services",
            terminalHeaderGrafik: "Price chart",
            terminalHeaderTO: "TO",
            terminalHeaderMessages: "Events history",
            terminalMaintenanceAddBtn: "Add TO",
            terminalMaintenanceEditTitle: "Edit TO",
            terminalMaintenanceDate: "Date of maintenance",
            terminalMaintenanceNext: "Next Maintenance",
            terminalMaintenanceTechName: "Specialist Name",
            terminalMaintenanceNote: "Notes",
            terminalMaintenanceId: "Maintenance application number",
            terminalMaintenanceDateCreate: "ticket creation date",
            terminalMaintenanceDeleteSuccess: "Data deleted",
            terminalMaintenanceAddSuccess: "TO added",
            terminalMaintenanceEditSuccess: "TO edited",
            terminalMaintenanceDeleteError: "Error while deleting data",
            terminalMaintenanceAddError: "Error while creating maintenance",
            terminalMaintenanceEditError: "Error while editing maintenance",
            terminalMessagesMessage: "Description",
            terminalMessagesServiceName: "Service",
            terminalMessagesDateCreated: "Date and time",
            terminalSendButton: "Money!",
            terminalSettingTitle: "Settings",
            terminalBonusPayLabel: "Bonus payment",
            terminalAfterPayLabel: "Bonuses accrual after payment",
            terminalBonusLabel: "Bonuses",
            terminalBonusPercentLabel: "Amount of bonuses accrued in% of the service cost",
            terminalBonusScheduleTitle: "Schedule for changing the accrual of bonuses",
            terminalBonusScheduleStart: "Start time",
            terminalBonusScheduleEnd: "End time",
            terminalBonusSchedulePercent: "Bonuses in%",
            terminalReboot: "Reload",
            terminalRebooting: "Rebooting",
            terminalStopWash: "Stop washing",
            terminalStopDeltaWash: "Stop",
            terminalCancelWash: "Cancel",
            terminalOpenGate: "Open gate",
            terminalCloseGate: "Close gate",
            terminalRunWash: "Run wash",
            terminalPauseWash: "Pause",
            terminalPlayWash: "Play",
            terminalOrgName: "Organization",
            terminalScreenTitle: "Terminal Screen",
            terminalStateTitle: "Terminal State",
            terminalErrorTitle: "Errors",
            terminalHeaderStatus: "Status",
            terminalHeaderPayTerm: "Payment terminal",
            terminalHeaderControlDevice: "Link to automation",
            terminalHeaderStarted: "Last Power On Date",
            terminalHeaderTempHum: "Temperature / Humidity terminal",
            terminalHeaderCooler: "Cooler",
            terminalHeaderHeater: "Heater",
            terminalHeaderBackLight: "Backlight",
            terminalHeaderBoxTemp: "Box temperature",
            terminalOnLabel: "Enabled",
            terminalOffLabel: "Off",
            terminalNotAvail: "Not Available",
            terminalOn2Label: "Enabled",
            terminalOff2Label: "Off",
            terminalLocked: "Locked",
            terminalCashCollector: "Cash Collector",
            terminalHideControl: "Hide control button",
            terminalStatesSelectScreen: "Mode selection",
            terminalStatesWaitPay: "Awaiting payment",
            terminalStatesPayment: "Payment",
            terminalStatesWashing: "Washing in progress",
            terminalSendSuccessMsg: "Message sent successfully.",
            terminalPriceScheduleAddBtn: "Add price change dates",
            terminalPriceScheduleAddTitle: "New price",
            terminalPriceScheduleEditTitle: "Price editing",
            terminalPriceScheduleStart: "Promotion start time",
            terminalPriceScheduleEnd: "End Time",
            terminalPriceScheduleType: "Service Type",
            terminalPriceSchedulePrice: "Price",
            terminalPriceScheduleDeleteTitle: "Delete schedule?",
            terminalPriceScheduleDeleteErr: "Error while deleting schedule",
            terminalPriceScheduleAddErr: "Error while creating the schedule. \ nChecking the correctness of filling in the fields",
            terminalPriceScheduleEditErr: "Error while editing the schedule. \ nChecking the correctness of filling in the fields",
            terminalPriceScheduleEditErr2: "Error while editing schedule",
            terminalServiceCreateTitle: "New Service",
            terminalServiceEditTitle: "Service Editing",
            terminalServiceEditSubTitle: "Service Mode",
            terminalServiceName: "Title",
            terminalServiceFullName: "Name in receipt",
            terminalServicePrice: "Price",
            terminalServiceIsWash: "Wash start",
            terminalServiceIcon: "Image",
            terminalServiceDesc: "Description",
            terminalServiceCode: "Service code",
            terminalServiceRelPos: "Current position",
            terminalServiceCode1Label: "Mode 1",
            terminalServiceCode2Label: "Mode 2",
            terminalServiceCode3Label: "Mode 3",
            terminalServiceCode4Label: "Mode 4",
            terminalServiceDeleteTitle: "Do you want to delete the service?",
            terminalServiceUpdateSuccess: "Service updated",
            terminalServiceUpdateError: "Service not updated, please try again",
            terminalServiceCreateSuccess: "Service created",
            terminalServiceCreateError: "Service not created, please try again",

            couponOnLabel: "Enabled",
            couponOffLabel: "Off",
            couponOnBtn: "Enable",
            couponOffBtn: "Off",
            couponPeriodLabel: "Select period",
            couponPieTitle: "",
        })
    ]
});
